import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root',
})
export class DevicePermissionService {
    private localStorageKey = 'ammsas_permissions_granted';

    constructor() { }

    hasPermissionsGranted(): boolean {
        return localStorage.getItem(this.localStorageKey) === 'true';
    }

    markPermissionsGranted() {
        localStorage.setItem(this.localStorageKey, 'true');
    }

}
